import React, { useCallback, useEffect } from "react";
import { INTRO_HINT_SCREEN_DURATION } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import useKeysPress from "../hooks/useKeysPress";

function Intro() {
  const navigate = useNavigate();
  const [step, setStep] = React.useState(0);
  const updateStep = useCallback(() => {
    setStep(1);
  }, [step]);

  useEffect(() => {
    let timeout: any;
    if (step == 1) {
      timeout = setTimeout(() => {
        navigate("/game");
      }, INTRO_HINT_SCREEN_DURATION);
    }
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [step]);

  useKeysPress([updateStep, updateStep, updateStep]);
  return (
    <section className="intro-container">
      {step == 0 && (
        <div className="confirmation-screen">
          <p className="">READY TO</p>
          <p>
            <span>PLAY</span>?!
          </p>
          <button onClick={updateStep}>YES</button>
        </div>
      )}
      {step == 1 && (
        <div className="hint-screen">
          <p>YOU'LL HAVE SOME QUESTIONS, AND YOUR MISSION IS TO CHOOSE </p>
          <p>THE CORRECT ANSWER</p>
        </div>
      )}
    </section>
  );
}

export default Intro;
